import Konva from "konva";
import { Options, useHotkeys } from "react-hotkeys-hook";
import { useMapCanvasShapes } from "../../../contexts/MapCanvasContext";
import { useMapCanvasStage } from "../../../contexts/MapCanvasContext/useMapCanvasStage";
import { useMapEditorActions } from "../../../contexts/MapEditorContext";
import { useMapEditorTool } from "../../../contexts/MapEditorContext";
import { createWallPath } from "../../../../../utils/shapeFactory";
import {
  findWallBridge,
  WallBridgeDirection
} from "../../../../../utils/wallBridge";
import { useEditorShortcuts } from "../EditorShortcutContext/useEditorShortcuts";
import { GLOBAL_SHORTCUTS_SCOPE } from "../shortcuts";

export const useWallBridgeShortcut = (
  stageRef: React.RefObject<Konva.Stage | null>
) => {
  const { activeTool } = useMapEditorTool();
  const { setShapes } = useMapEditorActions();
  const { shapes } = useMapCanvasShapes();
  const { stagePositionRef } = useMapCanvasStage();
  const { shortcuts } = useEditorShortcuts();

  const enabled = activeTool === "wall" || activeTool === "wall-path";

  const shortcutOptions: Options = {
    scopes: [GLOBAL_SHORTCUTS_SCOPE],
    enabled,
    preventDefault: true
  };

  const createBridge = (direction: WallBridgeDirection) => {
    const stage = stageRef.current;
    if (!stage) return;

    const pointerPos = stage.getPointerPosition();
    if (!pointerPos) return;

    const stagePosition = stagePositionRef.current;
    // Transform screen coordinates to canvas coordinates
    const cursorPosition = {
      x: (pointerPos.x - stagePosition.x) / stagePosition.scale,
      y: (pointerPos.y - stagePosition.y) / stagePosition.scale
    };

    const bridge = findWallBridge(cursorPosition, shapes, direction);
    if (!bridge) return;

    const newWall = createWallPath([bridge.start, bridge.end]);
    setShapes((prev) => [...prev, newWall]);
  };

  useHotkeys(
    shortcuts.global.wallBridgeHorizontal,
    () => createBridge("horizontal"),
    shortcutOptions,
    [
      shortcuts.global.wallBridgeHorizontal,
      shapes,
      activeTool
    ]
  );

  useHotkeys(
    shortcuts.global.wallBridgeVertical,
    () => createBridge("vertical"),
    shortcutOptions,
    [shortcuts.global.wallBridgeVertical, shapes, activeTool]
  );
};
